import vClickOutside from "v-click-outside";

export default {
	props: {
		items: Object,
		title: String,
		value: String,
		trackEventSource: String,
	},

	data() {
		return {
			showDropdown: false,
			activeFilter: "",
		};
	},

	computed: {},

	methods: {
		toggleDropdown,
		closeDropdown,
		handleItemSelect,
	},

	directives: { clickOutside: vClickOutside.directive },
};

function toggleDropdown() {
	this.showDropdown = !this.showDropdown;
}

function closeDropdown() {
	this.showDropdown = false;
}

function handleItemSelect(item) {
	this.$emit("input", item);
	this.closeDropdown();
}
